import React, {useState} from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import Welcome from './components/Welcome.jsx';
import Assessment from './components/Assessment.jsx';
import Results from './components/Results.jsx';
import Footer from './components/Footer.jsx';
import {BreedMatcher} from './utils/matching.js';
import './App.css';

function App() {
  const [currentScreen, setCurrentScreen] = useState('welcome');
  const [userResponses, setUserResponses] = useState({});
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);

  // Log when app loads to help with debugging
  React.useEffect(() => {
    console.log('FetchMate app loaded. Logo should be at: https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate.png');
  }, []);

  const handleStartAssessment = () => {
    setCurrentScreen('assessment');
  };

  const handleAssessmentComplete = async (responses) => {
    setLoading(true);
    setUserResponses(responses);
    
    // Simulate processing time for better UX
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    try {
      // Calculate matches
      const matcher = new BreedMatcher(responses);
      const results = matcher.calculateMatches();
      setMatches(results);
      setCurrentScreen('results');
    } catch (error) {
      console.error('Error calculating matches:', error);
      // Handle error gracefully
    } finally {
      setLoading(false);
    }
  };

  const handleBackToAssessment = () => {
    setCurrentScreen('assessment');
  };

  const handleBackToWelcome = () => {
    setCurrentScreen('welcome');
    setUserResponses({});
    setMatches([]);
  };

  const handleCancelAssessment = () => {
    setCurrentScreen('welcome');
    setUserResponses({});
    setMatches([]);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#f3ede6] to-white flex flex-col">
        <div className="flex-grow flex items-center justify-center">
          <div className="text-center">
            <div className="w-20 h-20 border-4 border-gray-200 border-t-[#F2674C] rounded-full animate-spin mx-auto mb-8"></div>
            <h2 className="text-3xl font-bold text-[#282f3a] mb-4">Analyzing Your Perfect Matches</h2>
            <p className="text-[#282f3a] font-medium max-w-md">Processing your responses and comparing with our comprehensive breed database...</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <Router>
      <div className="app-container flex flex-col min-h-screen">
        <div className="flex-grow">
          {currentScreen === 'welcome' && (
            <Welcome onStart={handleStartAssessment} />
          )}
          
          {currentScreen === 'assessment' && (
            <Assessment 
              onComplete={handleAssessmentComplete} 
              onBackToHome={handleBackToWelcome} 
              onCancel={handleCancelAssessment} 
            />
          )}
          
          {currentScreen === 'results' && (
            <Results 
              matches={matches} 
              onBack={handleBackToAssessment} 
              onBackToHome={handleBackToWelcome} 
            />
          )}
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;